import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { deliveryMenus } from "./menus";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Retour",
	updateManyExternalIntegrations: {
		success: "Integrations mises jour avec succs",
	},
	externalStoreIntegrationStatus: {
		synced: "Synchronisé",
		pendingSyncing: "Synchronisation en attente",
		pendingImporting: "Importation en attente",
	},
	ordersManager: {
		title: "Gestionnaire de commandes",
		description:
			"Suivez et gérez les commandes qui arrivent d'Entregue já, Comanda Online et Pedido na mesa.",
		filter: {
			placeholder: "Filtrer par",
		},
		tabs: {
			newOrders: "Nouvelles commandes",
			inDelivery: "En livraison",
			completed: "Terminées",
		},
		createOrder: "Créer une commande",
		loading: "Chargement",
		total: "Total: {{value}}",
		new: "Nouveau",
		emptyState: {
			title: "Aucune commande {{status}}.",
			description:
				"Nous vous enverrons une notification lorsque vous recevrez une nouvelle commande.",
		},
		immersion: {
			enter: "Immersion",
			exit: "Quitter l'immersion",
		},
		sound: {
			on: "Son activé",
			off: "Son coupé",
		},
		whatsNew: {
			intro: {
				title: "Du nouveau par ici ! 🎉",
				description:
					"Nous avons mis à jour le gestionnaire de commandes. Envie de voir vite ce qui a changé ?",
				start: "Voir les nouveautés",
			},
			step: "Étape {{current}} sur {{total}}",
			next: "Suivant",
			finish: "Compris",
			skip: "Passer",
			test: "Jouer un son d'exemple",
			immersion: {
				title: "Nouveau : Mode immersion",
				description:
					"Affichez le gestionnaire en plein écran, sans menus, idéal au comptoir.",
			},
			sound: {
				title: "Nouveau : Son de nouvelle commande",
				description:
					"Nous jouons une alerte sonore à l'arrivée d'une nouvelle commande. Utilisez le bouton pour l'activer ou la couper.",
			},
		},
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
